import { render, staticRenderFns } from "./UploadCVsModal.vue?vue&type=template&id=2d5a0d53&scoped=true"
import script from "./UploadCVsModal.vue?vue&type=script&lang=ts"
export * from "./UploadCVsModal.vue?vue&type=script&lang=ts"
import style0 from "./UploadCVsModal.vue?vue&type=style&index=0&id=2d5a0d53&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5a0d53",
  null
  
)

export default component.exports